module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/dropbox-7a697c7a.svg";